module.exports = __webpack_public_path__ + "img/undraw_empty_xct9.a5768414.svg";